import React from 'react';
import { FormattedMessage } from 'react-intl';
import UserTooling from '../../../tooling/userTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import Constants from '../../../definitions/constants';
import { intl } from '../../../locales/localesConfig';

import GlassPopup from '../common/interface/glassPopup';
import TextBox from '../common/inputs/textBox';
import CheckBox from '../common/inputs/checkBox';
import Select from '../common/inputs/select';
import ErrorFeedback from '../common/feedback/errorFeedback';
import SelectList from '../common/inputs/selectList';
import SupervisorModelsEditor from './supervisorModelsEditor';

const FormPopup = props => {
  const {
    handleShowPopup,
    handleOnChangeForm,
    handleButton,
    loadingButton,
    handleConfirmButton,
    loadingAlternativeButton,
    fullLoading,
    statusButton,
    formData,
    errors,
    entityNameSingular,
    popupState,
    groupsData,
    polynomialData, // array: Filtered polynomials list (they must be model), standard format: [{id: id, name: "name"}]
    biTemplatesData, // array: BiTemplates data, items contain polynomial_id and polynomial_name
    userProfile,
  } = props;
  let showConfirmButton = JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.id") ? (JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.is_active") ? null :  handleConfirmButton) : null
  return (
    <GlassPopup
      className="form_popup user_form_popup"
      title={(<FormattedMessage 
         id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      buttonText={(<FormattedMessage 
         id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      type={Constants.interface.popup.types.LATERAL}
      handleAlternativeButton={showConfirmButton}      
      alternativeButtonText={(<FormattedMessage id="userAdmin.confirmUserManually"/>)}
      {...props}
    >
      <ErrorFeedback
        status={statusButton}
        fieldErrors={errors}
        localesFieldsPath="userAdmin.fields"
      />
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        type={Constants.interface.inputs.type.EMAIL}
        id="email"
        data-path="user.email"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.email")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="userAdmin.fields.email"/>}
        className={"user_email_input" + (("email" in errors) ? " has_error" : " ")}
      />
      <div className="row_fields">
        <TextBox 
          styleType={Constants.interface.inputs.styleType.OUTLINED}
          type={Constants.interface.inputs.type.TEXT}
          id="first_names"
          data-path="user.first_names"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.first_names")}
          onChange={handleOnChangeForm}
          labelLocale={<FormattedMessage id="userAdmin.fields.first_names"/>}
        />
        <TextBox 
          styleType={Constants.interface.inputs.styleType.OUTLINED}
          type={Constants.interface.inputs.type.TEXT}
          id="last_names"
          data-path="user.last_names"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.last_names")}
          onChange={handleOnChangeForm}
          labelLocale={<FormattedMessage id="userAdmin.fields.last_names"/>}
        />
      </div>
      <Select 
        id="role"
        data-path="user.role"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.role")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="userAdmin.fields.role"/>}
        options={UserTooling.getUserRolesArray()}
      />
      <div>
        {(!userProfile.customer_is_single_sign_on) && (
          <React.Fragment>
            <label className="form_info">
              <FormattedMessage 
                id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.id") ? 
                  "userAdmin.form.passwordHelpEdit" : "userAdmin.form.passwordHelpCreate"}
              />
            </label>
            <TextBox 
              styleType={Constants.interface.inputs.styleType.OUTLINED}
              type={Constants.interface.inputs.type.PASSWORD}
              id="password"
              data-path="user.password"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.password")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="userAdmin.fields.password"/>}
              className={("password" in errors) ? "has_error" : null}
            />
            <TextBox 
              styleType={Constants.interface.inputs.styleType.OUTLINED}
              type={Constants.interface.inputs.type.PASSWORD}
              id="repeat_password"
              data-path="repeat_password"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"repeat_password")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="userAdmin.fields.repeat_password"/>}
              className={("repeat_password" in errors) ? "has_error" : null}
            />
          </React.Fragment>
        )}
        {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.id") && (
          <CheckBox 
            id="active"
            data-path="user.active"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.active")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="common.entity.fields.active"/>}
          />
        )}
        {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.role") != Constants.app.userRoles.SUPERVISOR) && (
          <React.Fragment>
            <label className="form_info">
              <FormattedMessage id="userAdmin.form.groupsHelp"/>
            </label>
            <SelectList        
              values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.groups")}
              onChange={handleOnChangeForm}
              data-path="user.groups"
              addSelectLocale={<FormattedMessage id="userAdmin.addGroupSelectLocale"/>}
              labelLocale={<FormattedMessage id="userAdmin.groupSelectTitle"/>}
              noMoreOptionsLocale={<FormattedMessage id="userAdmin.noMoreGroupsSelectLocale"/>}
              options={InterfaceTooling.getSelectArrayFromArrayOfObjects(groupsData, "id", "name", true, intl.formatMessage({id: "userAdmin.addGroupSelectLocale"}))}
              valueAccesor={"id"}
              labelAccesor={"name"}
              className={("groups" in errors) ? "has_error" : null}
            />
          </React.Fragment>
        )}
        {(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.role") == Constants.app.userRoles.SUPERVISOR) && (
          <SupervisorModelsEditor        
            values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"user.models_list")}
            onChange={handleOnChangeForm}
            data-path="user.models_list"
            id="models_list"
            modelsList={polynomialData}
            biTemplatesList={biTemplatesData}
            className={("models_list" in errors) ? "has_error" : null}
          /> 
        )} 
      </div>
    </GlassPopup>
  );
};

export default FormPopup;



// WEBPACK FOOTER //
// ./source/client/components/userAdmin/formPopup.jsx